import { Button, Center, Group, Select, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { NumOfBsd, NumOfGroup, PAGE_SIZE } from "CommonData"; // src/CommonData.js
import SRD_Form from "components/Form/index";
import { getBsdList } from "pages/Admin/Device/apis/adminDeviceApis";
import { getUserList } from "pages/Admin/User/apis/adminUserApis";
import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userState } from "pages/Login/atom/userState";
import { checkSameTelNo, insertSmsReceive, send_authcode } from "pages/SMS/ReceiveSetting/apis/receiveSettingApis";
import { authCodeState, currentBsdListState, generatedCodeState } from "pages/atom/globalState";
import { useRecoilState } from "recoil";
const generateRandomNumber = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};


function ReceiveSettingAddForm() {
  const [page, setPage] = useState(1);
  const [pageSize] = useState(PAGE_SIZE);
  const [noOfGroup] = useState(NumOfGroup);
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useRecoilState(userState);

  const [uId, setUId] = useState(user?.user_id || 'USER_ID');
  const [uName, setUName] = useState(user?.user_id || 'USER_NAME');
  const [userList, setUserList] = useState([]);
  const [phoneNo, setPhoneNo] = useState('');
  const group = user?.fn_group_id;

  const [bsdState, setBsdState] = useRecoilState(currentBsdState);
  const [selectedBsd, setSelectedBsd] = useState(bsdState);
  // const [bsdList, setBsdList] = useRecoilState(bsdListState); // bsdListState를 가져옴
  const [bsdListState, setBsdListState] = useRecoilState(currentBsdListState);

  const [authCode, setAuthCode] = useRecoilState(authCodeState);
  const [generatedCode, setGeneratedCode] = useRecoilState(generatedCodeState);
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (location.state && location.state.bsdState) {
      setBsdState(location.state.bsdState);
    }
  }, [location.state, setBsdState]);

  useEffect(() => {
    if (group !== "undefined") {
      getBsdList(NumOfBsd, 1, group).then((resList) => {
        if (resList && Array.isArray(resList)) {
            const formattedBsdList = resList.map((item) => ({
              value: item.bsd_id,
              label: item.bsd_nm,
            }));
            // setBsdListState([{ value: 'ALL', label: '전체' }, ...formattedBsdList]);
            setBsdListState(formattedBsdList);
            console.log("[ADD 151] formattedBsdList:", formattedBsdList);
          } else {
            console.log("선택할 장치 항목이 없습니다.");
            setBsdListState([]);
          }
      }, [bsdListState, setBsdListState]);

      getUserList(100, 1, group).then((resList) => {
        if (resList && Array.isArray(resList)) {
          const filteredList = resList.filter((item) => item.fn_group_id === group);
          if (filteredList.length > 0) {
            const formattedUserList = filteredList.map((item) => ({
              value: item.user_id,
              label: item.user_name,
              fn_mobile_nbr: item.fn_mobile_nbr,
            }));
            setUserList(formattedUserList);
            console.log("[ADD 172] formattedUserList:", formattedUserList);
          } else {
            console.log("선택할 사용자 항목이 없습니다.");
            setUserList([]);
          }
        } else {
          console.log("사용자 리스트가 로드되지 않았습니다.");
          setUserList([]);
        }
      });
    }
  }, []);
  
  const openAuthCodeModal = (data) => {
    const newAuthCode = generateRandomNumber();
    setGeneratedCode(newAuthCode);
    send_authcode(data, newAuthCode);   // 인증번호를 보내는 SMS
    setAuthCode('');
    console.log("[ADD 189] Generated new Auth Code:", newAuthCode);

    modals.openConfirmModal({   // [인증번호 받기 버튼 click
      title: "인증번호 입력 openConfirmModal",
      children: (
        <AuthCodeInput
          data={data}
          onConfirm={(confirmedData) => {
            insertSmsReceive({ ...confirmedData }, bsdState);
            setBsdState(bsdState);
            navigate("/sms/receive", { state: { bsdState, bsdListState } });
            modals.closeAll();
          }}
        />
      ),
      labels: { cancel: "취소" },
      onCancel: () => {
        console.log("[ADD 206] Modal 취소. authCode:", authCode);
      },
    });
  };

  const AuthCodeInput = ({ onConfirm, onCancel, formData, data, bsdState, bsdList, navigate }) => {
    const [authCode, setAuthCode] = useRecoilState(authCodeState); 
    const [generatedCode, setGeneratedCode] = useRecoilState(generatedCodeState);
    const [errorMessage, setErrorMessage] = useState('');
  
    useEffect(() => {
      console.log("[ADD 202] Generated Code:", generatedCode);
    }, [generatedCode]);
  
    const handleAuthCodeChange = (event) => {
      const value = event.target.value.replace(/[^0-9]/g, '').slice(0, 4);
      console.log("Input value:", value);
      setAuthCode(value);
      setErrorMessage('');
    };

    useEffect(() => {
      console.log("[ADD 213] Inputed Auth Code:", authCode);
    }, [authCode]);
  
    const handleConfirm = () => {
      console.log("< 확인 버튼 클릭후 > authCode:", authCode, "generatedCode:", generatedCode);
      if (authCode === generatedCode) {
        onConfirm(data);
      } else {
        setErrorMessage("올바른 인증번호를 입력해주세요."); // 오류 메시지 설정
        setAuthCode(''); // 인증번호 지우기
        document.getElementById('authCodeInput').value = '';
      }
    };
  
    return (
      <div>
        <Text size="sm" style={{ marginBottom: '1rem' }}>인증번호를 입력하세요</Text>
        <Group align="flex-end" spacing="xs">
          <div>
            <label htmlFor="authCodeInput" style={{ display: 'none' }}>인증번호</label>
            <input
              id="authCodeInput"
              type="text"
              inputMode="numeric"
              placeholder="인증번호"
              onChange={handleAuthCodeChange}
              style={{ 
                width: '120px', 
                padding: '8px', 
                border: '1px solid #ced4da', 
                borderRadius: '4px',
                fontSize: '14px'
              }}
              maxLength={4}
            />
          </div>
          <Button onClick={handleConfirm}>
            확인
          </Button>
          <Button onClick={() => {
            const resendCode = generateRandomNumber();
            setGeneratedCode(resendCode);
            send_authcode(data, resendCode);   // 인증번호를 재전송하는 SMS
            console.log("Resending auth code : ", resendCode);
            setAuthCode('');
            document.getElementById('authCodeInput').value = '';
          }}>
            재전송
          </Button>
        </Group>
        {errorMessage && ( // 오류 메시지가 있을 때만 표시
          <Text color="red" size="sm" style={{ marginTop: '1rem' }}>
            {errorMessage}
          </Text>
        )}
      </div>
    );
  };

  const onFormSubmit = async (data) => {
    console.log("[ADD 212] onFormSubmit> data: ", data);
    if (!data.sms_telno || data.sms_telno.length < 10 || data.sms_telno.length > 11) {
      alert("수신번호는 010XXXXYYYY 형태여야 합니다.");
      return;
    }
    await setFormData(data);

    const isSameTelNo = await checkSameTelNo(bsdState, data);
    if (!isSameTelNo) {
      openAuthCodeModal(data);
    } else {
      alert("이미 같은 번호가 등록되어 있습니다");
      return;
    }
  };
  
  const BsdSelect = ({ field }) => (
    <Select
      {...field}
      data={bsdListState}
      value={selectedBsd}
      onChange={(value) => {
        setSelectedBsd(value);
        field.onChange(value);
      }}
    />
  );

  const columns = useMemo(() => {
    console.log("[ADD 230] columns> bsdState:", bsdState);
    console.log("[ADD 231] columns> bsdList:", bsdListState);
    // console.log("[ADD 232] columns> BsdSelect:", BsdSelect);

    const baseColumns = [
      {
        key: "bsd_nm",
        name: "SMS 분사 장치",
        type: "text",
        defaultValue: bsdListState.find(item => item.value === bsdState)?.label || '기본값',
      },
      {
        key: "user_name",
        name: "SMS 수신자",
        type: "text",
        onChange: (e) => {
          console.log("[ADD 248] columns> SMS_RECEIVER:", e.target.value);
          setUName(e.target.value);
        },
      },
      {
        key: "sms_telno",
        name: "SMS 수신 번호",
        type: "phone_number",
        value: phoneNo,
        onChange: (value) => {
          if (value.length <= 11) {
            setPhoneNo(value);
          } else {
            // 에러 메시지 설정
            console.error("[ERROR] 수신번호는 11글자 이내여야 합니다.");
            // 추가적인 에러 처리 로직 필요
          }
        },
      },
    ];

    return baseColumns;
  }, [bsdListState, bsdState, setBsdState, setUName, phoneNo]);


  const SubmitButtons = () => {
    const handleCancel = () => {
      navigate("/sms/receive", { state: { bsdState, bsdListState } });
      console.log("[ADD 268] 취소 bsdState:", bsdState);
      console.log("[ADD 269] 취소 bsdList:", bsdListState);
    };

    return (
      <Center style={{ marginTop: "1rem", display: "flex", justifyContent: "space-between" }}>
        <Button type="submit" style={{ marginRight: "1rem" }}>인증번호 받기</Button>
        <Button type="button" onClick={handleCancel}>취소</Button>
      </Center>
    );
  };


  return (
    <SRD_Form
      fields={columns}
      onSubmit={onFormSubmit}
      submitButton={<SubmitButtons />}
    />
  );
}

export default ReceiveSettingAddForm;